import { commonServerSideProps } from '@/lib/commonPageStaticProps';
import { CacheHeaderType } from '@/lib/revalidate';
import { SeoConfigBuilder } from '@/lib/seo/SeoVariables';
import { OrderStatusView } from '@/views/OrderStatusView/OrderStatusView';

export const getServerSideProps = commonServerSideProps(async () => {
  return {
    props: {
      seoConfig: new SeoConfigBuilder().setNoIndex().build(),
    },
  };
}, CacheHeaderType.OTHER);

export default OrderStatusView;
